<script setup>
import { computed } from 'vue';
import {
  deltaPillClass,
  formatDeltaLabel,
  resolvePeriodDelta,
} from './buzzScoreDistribution';

const props = defineProps({
  periodDelta: {
    type: [Number, String],
    default: null,
  },
  history: {
    type: Array,
    default: () => [],
  },
  score: {
    type: [Number, String],
    default: null,
  },
});

const delta = computed(() =>
  resolvePeriodDelta(props.periodDelta, props.history, props.score)
);
const label = computed(() => formatDeltaLabel(delta.value));
const pillClass = computed(() => deltaPillClass(delta.value));
</script>

<template>
  <span v-if="label" :class="pillClass">{{ label }}</span>
</template>
